import { atom } from 'recoil';

const initialData = '';

export const BranchAtom = atom({
  key: 'branch-data',
  default: initialData as string,
});
